import {ReactComponent as PlusIcon} from '../assets/image/plus.svg';
import AppSettingController from "../../Main/controller/AppSettingController";
import InvoiceInterface from "../interface/invoiceInterface";
import React from "react";
import DiscountController from "../Controller/DiscountController";
import {useTranslation} from "react-i18next";

export default function DiscountRow({state, setState}: {
    state: InvoiceInterface,
    setState: React.Dispatch<React.SetStateAction<InvoiceInterface>>
}) {
    const {t} = useTranslation();

    if (AppSettingController.isHiddenPrice())
        return null

    if (state.discount.isApplyDiscount)
        return null

    return (
        <div className="toggle-form-discount"
             onClick={e => new DiscountController(state, setState).toggleFormDiscount()}>
            <p>{t("invoice.discountCodeQuestion")}</p>
            <PlusIcon className={state.discount.show ? 'active' : 'de-active'}/>
        </div>
    );
}